module.exports = __webpack_public_path__ + "img/0Q3B2213_L_Black_MockedUp.8fabda3d.jpg";